/**
 * Footer Component Styles
 * Demonstrates using design tokens from @config
 */

import styled from 'styled-components';
import { colors } from '@config/seafoam_colors';
import { typography } from '@config/typography';
import { spacing } from '@config/spacing';
import { app } from '@config/constants';
import { media } from '@config/breakpoints';

/**
 * Footer container
 */
export const FooterContainer = styled.footer`
  background-color: ${colors.surface};
  border-top: 1px solid ${colors.border};
  margin-top: auto;
  min-height: ${app.footerHeight};
`;

/**
 * Footer content wrapper
 */
export const FooterContent = styled.div`
  max-width: ${app.maxContentWidth};
  margin: 0 auto;
  padding: ${spacing['3xl']} ${spacing['2xl']};

  ${media.md} {
    padding: ${spacing['4xl']} ${spacing['3xl']};
  }
`;

/**
 * Footer grid layout
 */

/**
 * Footer section
 */

/**
 * Footer section title
 */

/**
 * Footer link
 */
export const FooterLink = styled.a`
  font-family: ${typography.fontFamily.body};
  font-size: ${typography.fontSize.base};
  color: ${colors.textSecondary};
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: ${colors.primary};
  }
`;

/**
 * Footer bottom section
 */
export const FooterBottom = styled.div`
  margin-top: ${spacing['3xl']};
  padding-top: ${spacing['2xl']};
  border-top: 1px solid ${colors.border};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing.lg};
`;

/**
 * Footer links container
 */
export const FooterLinks = styled.div`
  display: flex;
  gap: ${spacing.xl};
  align-items: center;
`;

/**
 * Footer copyright
 */
export const FooterCopyright = styled.div`
  font-family: ${typography.fontFamily.body};
  font-size: ${typography.fontSize.sm};
  color: ${colors.textSecondary};
`;
